import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnDestroy, AfterViewInit, OnInit, ViewChild } from '@angular/core';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { MatDrawer } from '@angular/material/sidenav';

/** @title Responsive sidenav */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: ['full.component.scss']
})
export class FullComponent implements OnDestroy, AfterViewInit, OnInit {
  mobileQuery: MediaQueryList;
  isMobileView: any;
  private _mobileQueryListener: () => void;
  @ViewChild('snav') snav: MatDrawer;
  sidebarClosed = false;
  sidebarIcon: string = 'menu';  // Initialize with 'menu'

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  
  ngAfterViewInit() { }

  ngOnInit(): void {
    window.addEventListener("resize", () => {
      this.checkIfMobileView();
    });

    this.checkIfMobileView();
  }

  checkIfMobileView() {
    this.isMobileView = window.innerWidth < 768;
  }

  toggleSidebar(): void {
    this.snav.toggle();
    this.sidebarIcon = this.snav.opened ? 'menu' : 'menu_open';
  }

  drawerClosed(): void {
    this.sidebarIcon = 'menu';  // Change to 'menu' when closed
    this.sidebarClosed = true;
  }

  drawerOpened(): void {
    this.sidebarIcon = 'menu_open';  // Change to 'menu_open' when opened
    this.sidebarClosed = false;
  }
}
